/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @angular-eslint/no-host-metadata-property */
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, ElementRef, Input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { LcsChipGrid } from '../chip-grid/chip-grid';
import { LcsChipInput } from './chip-input';

let nextUniqueId = 0;

@Directive({
   // eslint-disable-next-line @angular-eslint/directive-selector
   host: {
      '(blur)': 'onBlur()',
      '(focus)': 'onFocus()',
      '(keydown)': 'onKeydown($event)',
      '[attr.aria-invalid]': 'chipGrid?.chipList ? chipGrid.chipList : null',
      '[attr.aria-required]': 'chipGrid || null',
      '[attr.disabled]': 'disabled || null',
      '[attr.placeholder]': 'placeholder || null',
      '[id]': 'id',
      'class': 'lcs-chip-input',
   },
   selector: '[lcsChipInput]',
   standalone: false,
})
export class LcsChipInputDirective<TItem> implements LcsChipInput<TItem>, MatChipsModule {
   /** Unique id for the input. */
   @Input() id = `lcs-chip-input-${nextUniqueId++}`;

   /** The input's placeholder text. */
   @Input() placeholder = '';

   /** Whether the input is disabled. */
   @Input()
   set disabled(value: boolean) {
      this._disabled = coerceBooleanProperty(value);
   }

   get disabled(): boolean {
      return this._disabled || this.chipGrid?.disabled;
   }

   private _disabled = false;

   /** Whether the control is focused. */
   focused = false;

   get empty(): boolean {
      return !this.elementRef.nativeElement.value;
   }

   chipGrid: LcsChipGrid<TItem>;

   constructor(public elementRef: ElementRef<HTMLInputElement>) {}

   registerChipGrid(chipGrid: LcsChipGrid<TItem>): void {
      this.chipGrid = chipGrid;
   }

   focus(options?: FocusOptions): void {
      this.elementRef.nativeElement.focus(options);
   }

   onBlur(): void {
      this.focused = false;
   }

   onFocus() {
      this.focused = true;
   }

   onKeydown(event?: KeyboardEvent): void {
      if (this.empty && !!event) {
         this.chipGrid.chipList._keydown(event);
      }
   }
}
